import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
	Box,
	LazyImage,
	SpanStyled,
} from "../../ui/Elements";
import { FooterLogoAr, FooterLogoEn, MinistryLogo1, MinistryLogo2 } from "../../ui/AllImages";
import { Link } from "react-router-dom";



const Footer = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();
	const date_year = new Date();
	const FowlUrl = () => {
		const whatsappURL = "https://fowl.sa/home";
		window.open(whatsappURL, "_blank");
	};
	const FowlWeb = () => {
		window.open("https://websites.fowl.sa/", "_blank");
	};
	return (
		<FooterWrapper className="container-fluid footerWrapper" lang={language}>
			<Box className="footerCrWrapper">
				<Container className="footerContain2">
					<Row className="footer-row align-items-center justify-content-center justify-content-sm-between">
						<Box className="footerLogo mt-2">
							{language === "ar" ? (
								<FooterLogoAr />
							) : (
								<FooterLogoEn />
							)}
						</Box>
						<Box className="text-center copyright mt-2">
							<SpanStyled
								className="footer-op"
								size="16px"
								color="var(--bg2)"
								transform="capitalize"
							>
								{t("Copyright")} &copy; {date_year.getFullYear()}
								<SpanStyled
									className="footer-op footer-op-company"
									size="16px"
									color="var(--themeColor)"
									family="var(--bold)"
								>
									&nbsp;{t("SOLA")}.
								</SpanStyled>
							</SpanStyled>
							<SpanStyled
								className="footer-op footer-op-allRights"
								size="16px"
								color="var(--bg2)"
								transform="capitalize"
							>
								&nbsp;{t("AllRightReserved2")}
							</SpanStyled>
						</Box>
						<Box className="ministryLogosWrapper">
							
							<Box className="minLogo">
								<Link to="#!"><LazyImage src={MinistryLogo2} /></Link>
							</Box>
							<Box className="minLogo">
								<Link to="#!"><LazyImage src={MinistryLogo1} /></Link>
							</Box>
						</Box>

					</Row>
				</Container>
			</Box>
		</FooterWrapper>
	);
};

export default Footer;
